module.exports = __webpack_public_path__ + "svg_80x80/redux.ea4cb7.svg";